module.exports = __webpack_public_path__ + "images/vc-dfb728.svg";